import { ProductQuery } from 'shared/types/query/ProductQuery';
import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { Product } from 'types/entity/product';

const useProduct = ({ query, limit }: Partial<ProductQuery> = {}) => {
  const sdk = useSdk();
  const { data: productsData } = useSWR(['/action/product/search', query, limit], () =>
    sdk.composableCommerce.product.search({ query, limit }),
  );

  const products = (productsData?.isError ? [] : (productsData?.data?.items as Product[])) ?? [];

  return { products };
};

export default useProduct;
